import { render, staticRenderFns } from "./individualTestSetupForm.vue?vue&type=template&id=7552e38e"
import script from "./individualTestSetupForm.vue?vue&type=script&lang=js"
export * from "./individualTestSetupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports